import React from "react"
import Styles from "@/components/GlobalVisualSearch/SearchNotification/index.module.scss"
import {
  SearchIcon,
  SearchNotificationIcon,
} from "@/components/GlobalVisualSearch/SearchNotification/icons"
import { useSelector } from "react-redux"
import { selectGenericState } from "@/store/features/genericSlice"

const SearchNotification = props => {
  const { isFirstTime, onClickHandler } = props
  const { featureFlags = {} } = useSelector(selectGenericState)
  const {
    ENABLE_GLOBAL_VISUAL_SEARCH_V1: isGlobalVisualSearchEnabled = false,
  } = featureFlags

  return (
    <div className={`${Styles.SearchNotificationContainer}`}>
      <button
        onClick={() => {
          onClickHandler && onClickHandler()
        }}
      >
        {isFirstTime && isGlobalVisualSearchEnabled ? (
          <SearchNotificationIcon />
        ) : (
          <SearchIcon />
        )}
      </button>
    </div>
  )
}

export default SearchNotification
